import React from 'react';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Menu from './Menu';
import Accommodation from './Accommodation';
import { Helmet } from 'react-helmet';
import { UserType } from '../Models/UserType';
import { useStore } from '../Stores/store';
import Gifting from './Gifting';

const MainPage = () => {
    const { generalStore } = useStore();
    const { userType } = generalStore;

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>H&R Wedding | Home</title>
            </Helmet>
            <Home />
            <About />
            { userType === UserType.DayGuest && <Menu /> }
            <Accommodation />
            <Gifting />
            <Contact />
        </>
    )
}

export default MainPage;